import React from "react";
import { Nav } from "../layouts/headernew";
import { ToothZapFooter2 } from "../layouts/footernew";
import "../style/terms.css";
export const RefundPolicy: React.FC = () => {
  return (
    <div>
      <Nav />

      {/* LEGAL SECTION */}
      <section className="legal-section">
        <div className="legal-container">
          <h1 className="legal-title">Refund Policy</h1>
          <p className="legal-date">Last updated: March 13, 2026</p>

          <div className="legal-content">
            <p>
              ToothZap operates as a workflow and partner-network service, so any
              refund treatment depends on the nature of the commercial arrangement,
              onboarding stage, and the service actually delivered. Informational site
              access and demo requests do not create a refund obligation by
              themselves.
            </p>

            <p>
              If a clinic, lab, or partner has entered into a paid arrangement with
              ToothZap, refund eligibility will normally be assessed against the
              applicable commercial terms, work already performed, materials
              committed, and operational costs already incurred. Requests are reviewed
              case by case rather than granted automatically.
            </p>

            <p>
              Refunds are generally less likely where a workflow setup, onboarding
              review, scheduling effort, partner allocation, or operational support
              has already been provided. Refunds may also be limited or declined where
              delays, cancellations, or interruptions arise from incomplete user
              information, missed coordination windows, or circumstances outside
              ToothZap’s reasonable control.
            </p>

            <p>
              Users seeking a refund should contact ToothZap using the published
              contact details and include the relevant transaction, agreement, or
              communication history. ToothZap may request supporting details before a
              decision is made, including timeline information, payment records, and
              the scope of work that had already begun.
            </p>

            <p>
              This policy is intended as a general website-level summary and may be
              supplemented by separate commercial documents, invoices, onboarding
              terms, or partner agreements. Where a signed commercial agreement
              exists, that agreement will control over this page to the extent of any
              direct conflict.
            </p>
          </div>
        </div>
      </section>

      <ToothZapFooter2 />
    </div>
  );
};

export default RefundPolicy;